<template>
  <v-app v-cloak>
    <v-navigation-drawer class="home-navigationdrawer mb-5" v-model="sidebar" app >
    
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
		  <v-list-tile-action>            
          </v-list-tile-action>
          <v-list-tile-title class="title">
			  <v-icon  :color="naviconcolor">wb_cloudy</v-icon> {{ appTitle }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    
    <v-flex v-if="$store.state.user && ( $store.state.user.displayName != '' || $store.state.user.emailaddress != '')">
    
		<v-divider style="border-color:#fff"></v-divider>
		<v-layout row wrap>
        
            <!--<v-flex  xs12  md12  class="text-xs-center pa-0" v-if="$store.state.user.displayName">
                 <pre> {{ $store.state.user }} </pre>
            </v-flex>-->
        
        
			<v-flex  xs12  md12  class="text-xs-center pa-0" v-if="$store.state.user.displayName">Welcome {{ $store.state.user.displayName }},
            <template v-if="$store.state.user.Type == 'Subaccount'" >({{ $store.state.user.abitsubaccountrole_id }})</template>
            </v-flex>
			<v-flex  xs12  md12  class="text-xs-center pa-0" v-else>Welcome {{ $store.state.user.emailaddress }},   </v-flex>
            
            <v-flex  xs12  md12  class="text-xs-center pa-0" v-if="androidid"># {{ androidid }},   </v-flex>
            
            <v-flex   xs12  md12  class="text-xs-center pa-0" v-if="dfrom && dtomenuid && $store.state.user.Type !== 'Subaccount'">  
                <v-btn small flat :to="`/voip-conversations/${dtomenuid}/details`"  class="pr-0" >{{ dfrom }} &nbsp;</v-btn>
                <v-btn small icon  v-on:click="directsubscribe(userid,dfrom)" class="pl-0" ><v-icon  :color="phcolor.color">mdi mdi-record</v-icon></v-btn>
            </v-flex>
            <v-flex   xs12  md12  class="text-xs-center pa-0" v-else-if="$store.state.user.Type !== 'Subaccount'  ">  <v-btn small flat :to="`/`" Get Your VOIP</v-btn></v-flex>
            
            <!-- <v-flex   xs12  md12  class="text-xs-center pa-0" v-if="dfrom && dtomenuid && phcolor.status!=''">
               {{ phcolor.status }} ,  {{ phcolor.Direction }} 
             </v-flex>-->
            
           <!-- <v-flex class="text-xs-center pa-0" v-if="typeof $store.state.user.sid!=='undefined'">Slack# {{ $store.state.user.sid }},   </v-flex>-->
		</v-layout>
<!--
		<v-divider></v-divider> 
-->
    </v-flex>
      <v-list dense class="pt-0"> 
		 <!-- Sidebar 3 level Menu  -->  
                        <template  v-for="(items,sub) in newmenu"   >
                           <v-list-tile  v-on:click="callfn(items)"  :to="items.to"  v-if="displaycondition(items) && items.dynamicsubitems == false"  >
                              <v-list-tile-action>
                                 <v-icon>{{items.icon}}</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                 <v-list-tile-title>{{ items.title }}</v-list-tile-title>
                              </v-list-tile-content>
                           </v-list-tile>
                           <v-list-group  :prepend-icon="items.icon"  v-if="dynamicmenu( items.dynamicsublistcall ).length > 0 && displaycondition(items) && items.dynamicsubitems == true">
                              <v-list-tile avatar slot="activator">
                                 <v-list-tile-content>
                                    <v-list-tile-title>{{ items.title }}</v-list-tile-title>
                                 </v-list-tile-content>
                              </v-list-tile>
                              <!-- Home and add list icons div-->
                              <template v-if="items.homelist.length > 0 ">
                                 <v-subheader inset class="homelist" v-if=" $store.state.user.Type !== 'Subaccount'">
                                    <template    v-for="(subhome,s) in items.homelist"  >
                                       <v-tooltip top>
                                          <v-btn flat  slot="activator" class="pa-0 ma-0" small   :to="subhome.to" icon :key="`subhomelists${s}${subhome.title}`">
                                             <v-icon>{{ subhome.icon }}</v-icon>
                                          </v-btn>
                                          <span>{{ subhome.title }} </span>
                                       </v-tooltip>
                                    </template>
                                 </v-subheader>
                              </template>
                              <!-- Home and add list icons div-->
                              <!-- Static Menus starts-->
                              <template  v-if="items.subitems.length > 0 && $store.state.user.Type !== 'Subaccount'">
                                 <v-list-tile  v-for="linklist in items.subitems" :key="`linklist${sub}${linklist.title}`" link :to="linklist.to" avatar >
                                    <v-list-tile-action>
                                       <v-icon   :color="naviconcolor">{{linklist.icon}}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                       <v-list-tile-title>{{linklist.title}}</v-list-tile-title>
                                    </v-list-tile-content>
                                 </v-list-tile>
                              </template>
                              <!-- Static Menus ends-->
                              <!-- Dynamic Menus Starts-->
                              <template  v-if="items.dynamicsubitems">
                                 <template v-for="(sublistItem,sublistItemi) in dynamicmenu( items.dynamicsublistcall )"    >
                                    <template v-if="sublistItem.subitems !== undefined && sublistItem.subitems.length > 0">
                                       <!---Dynamic listing with Sublevels of menu -->
                                       <v-list class="third-level dense ">
                                          <v-list-group  sub-group class="second--sub-group" >
                                             <v-list-tile avatar slot="activator">
                                                <!--<v-list-tile-action> <v-icon color="primary">{{sublistItem.icon}}</v-icon>  </v-list-tile-action>-->
                                                <v-list-tile-content>
                                                   <v-list-tile-title class="text--primary " style="color:#1976d2 !important;">{{ sublistItem.title }}</v-list-tile-title>
                                                   <!--<v-list-tile-sub-title>{{ sublistItem.modified | formatdate  }}</v-list-tile-sub-title>-->
                                                </v-list-tile-content>
                                             </v-list-tile>
<!--
                                             <v-list   class=" pl-3 py-0"  v-for="(dysublistItem,dysublistItemi) in sublistItem.subitems" :key="`dynamicsamples${dysublistItemi}${sublistItemi}`">
                                                <v-list-tile   class="pl-5" v-on:click=""  :to="dysublistItem.to">
                                                   <v-list-tile-title>{{ dysublistItem.title }}</v-list-tile-title>
                                                </v-list-tile>
                                             </v-list>
-->
                                             <v-list>
											<template v-for="(dysublistItem,dysublistItemi) in sublistItem.subitems" > 
											<template  v-if="dysublistItem.nextsubitems !== undefined && dysublistItem.nextsubitems.length > 0 && $store.state.user.Type !== 'Subaccount'">
                                                
                                             <v-list-group  sub-group class="second--sub-group" > 
                                                <v-list-tile   class="pl-5" v-on:click=""  :to="dysublistItem.to">
                                                   <v-list-tile-title> {{ dysublistItem.title }}</v-list-tile-title> 
                                                </v-list-tile>
                                                
													<v-list   class=" pl-3 py-0"  v-for="(dynextsublistItem,dynextsublistItemi) in dysublistItem.nextsubitems" :key="`dynamicnextsamples${dynextsublistItemi}${dysublistItemi}${sublistItemi}`">
														 
														<v-list-tile   class="pl-5" v-on:click=""  :to="dynextsublistItem.to"> 
														   <v-list-tile-title>{{ dynextsublistItem.title }}</v-list-tile-title> 
														</v-list-tile>
														
													 </v-list>
											 </v-list-group>  
											 </template>
											 <template v-else>  
												 <v-list-tile   class="pl-5" v-on:click=""  :to="dysublistItem.to">
                                                   <v-list-tile-title> {{ dysublistItem.title }}</v-list-tile-title> 
                                                </v-list-tile>
											 </template>
												                                            
                                             </template>
                                             </v-list>
                                             
                                             
                                          </v-list-group>
                                       </v-list>
                                    </template>
                                    <template v-else>
                                       <!---Dynamic listing with single of menu -->
                                       <v-list-tile class="pl-5"   v-on:click="route(sublistItem.click)" :to="sublistItem.to"  v-if="sublistItemi < 18 && (typeof sublistItem.items == 'undefined') ">
                                          
                                          <v-list-tile-action v-if="items.dynamicsublistcall=='chatmenu'">
                                              <v-avatar  color="primary" size="32px" >
                                                    <v-badge color="white" bottom     >
                                                      <template  slot="badge"  >
                                                        <v-icon   small >chat</v-icon>
                                                      </template>
                                                      <span class="white--text title font-weight-bold">{{ sublistItem.icontitle }}</span>
                                                    </v-badge>
                                                </v-avatar>
                                          </v-list-tile-action>
                                          <v-list-tile-action v-else>
                                             <v-icon   :color="naviconcolor">{{sublistItem.icon}}</v-icon>
                                          </v-list-tile-action>
                                          
                                          
                                          <v-list-tile-content>
                                             <v-list-tile-title>{{ sublistItem.title }}</v-list-tile-title>
                                             <v-list-tile-sub-title>{{ sublistItem.modified | formatdate  }}</v-list-tile-sub-title>
                                          </v-list-tile-content>
                                       </v-list-tile>
                                       <v-list-tile    v-else-if="sublistItemi == 18 "   v-on:click="route(sublistItem.click)" :to="sublistItem.to"  >
                                          <v-list-tile-action>
                                             <v-icon   :color="naviconcolor">more_horiz</v-icon>
                                          </v-list-tile-action>
                                          <v-list-tile-content>
                                             <v-list-tile-title>more..</v-list-tile-title>
                                          </v-list-tile-content>
                                       </v-list-tile>
                                    </template>
                                 </template>
                              </template>
                              <!-- Dynamic Menus ends-->
                           </v-list-group>
                        </template>



		 <v-list-tile v-for="item in menuItems" :key="item.title" :to="item.path" v-if="($store.state.user && ( item.userType =='' || item.userType == $store.state.user.Type)) || !$store.state.user">
			<v-list-tile-action>
				<v-icon>{{ item.icon }}</v-icon>
			</v-list-tile-action>
			<v-list-tile-content>{{ item.title }}</v-list-tile-content>
		 </v-list-tile>  
	 	 
<!--
		 <pre>{{ sortingmenu }}</pre>
-->
	   
        <v-list-tile   @click="userSignOut()"   v-if="$store.state.user">
			<v-list-tile-action>
				<v-icon>exit_to_app</v-icon>
			</v-list-tile-action>
			<v-list-tile-content>LOGOUT</v-list-tile-content>
		</v-list-tile>  
          
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app   :color="navcolor"  class="home-headertoolbar"   dark>
      <span class="hidden-sm-and-up3">
        <v-toolbar-side-icon @click="sidebar = !sidebar">
        </v-toolbar-side-icon>
      </span>
      <v-toolbar-title v-if="!sidebar">
        <router-link to="/" tag="span" style="cursor: pointer" >
         <v-icon :color="naviconcolor">wb_cloudy</v-icon>  {{ appTitle }} 
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
		<!-- Header single Menu  -->  
		<v-btn  flat v-for="item in menuItems"  :key="item.title" :to="item.path" v-if="($store.state.user && ( item.userType =='' || item.userType == $store.state.user.Type)) || !$store.state.user">
		<v-icon left dark :color="naviconcolor">{{ item.icon }}</v-icon>
		{{ item.title }}
		</v-btn>
		<!-- Header Sub Menu  -->   
		 
       
        <v-btn  flat    @click="userSignOut()"   v-if="$store.state.user">
		<v-icon left dark :color="naviconcolor">exit_to_app</v-icon> LOGOUT </v-btn>

      </v-toolbar-items>
    </v-toolbar>
    
    <v-content class="english mb-5">
		<v-snackbar v-model="snack" :timeout="6000" :top="top" :multi-line='multiline' :color="snackColor">
		  {{ snackText }}
		  <v-btn flat @click="snack = false">Close</v-btn>
		</v-snackbar>
		 <!--
		<v-progress-linear :indeterminate="$store.state.pageloading" style="margin:0px" color="amber"></v-progress-linear>
		{{ $store.state.pageloading }}-->
		 
		 <!-- breadcrumbs from routers-->
		<!--<Breadcrumbs></Breadcrumbs>--> 
		<router-view></router-view>
        
        
        <!-- <template ><pre> {{ $store.state.allconvmessages }} a:{{ allconvmessages }} </pre> </template>-->
    </v-content>
    
     
    
    <!--  hide-overlay  -->
    <v-dialog v-model="loaddialog" persistent width="300"  >
      <v-card  color="amber" dark >
        <v-card-text>
          Loading..
          <v-progress-linear  indeterminate color="white" class="mb-0" ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
   <!-- <template   >
     <v-dialog v-model="openphone" persistent width="275" content-class="openphone"   >
           <Dialer />
     </v-dialog>
    </template> -->
    
   <v-footer class="pa-3"    >
   
    <v-spacer></v-spacer>
    <!--<div>{{ footerTitle }} &copy; {{ new Date().getFullYear() }}</div>-->
    
    
    <template v-if="$store.state.user">
      
          <template v-if="incoming && acceptcall==false">
             <v-btn small flat color="green"     @click="accept()" >  <v-icon>mdi mdi-phone-in-talk mdi-spin</v-icon> Accept  </v-btn>
             <v-btn  small flat  color="red"    @click="reject()" >  <v-icon>call_end</v-icon> Reject  </v-btn>
         </template>
                    
                    
         <div class="text-xs-right" v-if="$store.state.user.Type !== 'Subaccount'  ">
      <!-- isMobile:  {{ isMobile() }}--><!--{{ sheet }}-->
            <v-bottom-sheet     v-model="sheet" :full-width="!isMobile()" :inset="isMobile()">
              <template  slot="activator">

                  <v-toolbar  flat dense >
                   <v-btn small flat :to="`/voip-conversations/${dtomenuid}/details`"  class="pr-0" >{{ dfrom }} &nbsp;</v-btn>
                   {{ log }}
                    <v-spacer></v-spacer>
                    
                    <v-btn  icon   color="green"  v-if="sheet" dark >  <v-icon>close</v-icon>   </v-btn>
                   <v-btn  icon   color="pink"   v-else  dark  >  <v-icon>dialpad</v-icon>  </v-btn>
                  </v-toolbar>
 
               	
              </template>
              <v-card tile>
                    <Dialer />
              </v-card>
            </v-bottom-sheet>
          </div>
         
        </template>
    
   </v-footer>
   
   
   
   
  </v-app>
</template>

<script>
 import moment from 'moment';
import 'vue-tel-input/dist/vue-tel-input.css';
import Breadcrumbs from './components/Includes/Breadcrumbs'
import Dialer from './components/Inbrowser/Pop.vue';
import io from 'socket.io-client';

  export default {
    data () {
      return {
        // appTitle: 'Awesome App',
		 androidid:'',
		 inboxmsgpre : 'INBOX', 
		 sheet: false,
         socket : '',
		 mobilestatus:[],
		 sidebar: true,
		 multiline: false,
		 top: true,
		 items: [
			'Team Members', 'Configurations', 'Contacts/Groups' 
		  ],
		  
		  newmenu: [
		{ title: 'MY DESK',  icon: 'dashboard',userType: ''  ,isMobileview: '', active: true,    showhead: false, to: '/mydesk/home',items:[],dynamicsubitems:  false, },
		//{ title: 'FAVOURITES',  icon: 'favorite',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/mydesk/FAVOURITES',items:[],dynamicsubitems:  false, },
		{ title: 'OUR MENU',  icon: 'list',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/ourmenu',items:[],dynamicsubitems:  false, },
		{ title: 'MY RECENT EVENTS',  icon: 'history',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/mydesk/logs',items:[],dynamicsubitems:  false, },
		//{ title: 'API',  icon: 'api',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/mydesk/logs',items:[],dynamicsubitems:  false, },
		
		{ icon: 'today',userType: ''  , title: 'PROJECT MANAGEMENT', click:'', isMobileview: '', active: true,    showhead: false,items:[],
		   homelist: [
			 { icon: 'home',userType: 'Master'  , title: 'Dashboard', to: '/checklist/lists/all',click:'' },
			 { icon: 'add',userType: 'Master'  , title: 'Add New', to: '/checklist/projectsettings/',click:'' },
			 { icon: 'list',userType: 'Master'  , title: 'View Listing', to: '/checklist/lists/all',click:'' },
		   ],
		   dynamicsubitems:  true,
		   dynamicsublistcall:   'projectmenu' ,
		   subitems: [ ]
		 },
		 { title: 'DIALER',icon: 'dialpad',userType: '',isMobileview: true, active: true,showhead: false, to: '/dialer',items:[],dynamicsubitems:  false, }, 
		 //click:'sheet',
		 { icon: 'rss_feed',userType: ''  , title: 'CMS', click:'', isMobileview: false, active: true,    showhead: false,items:[],
		   homelist: [
			  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/blogs',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add CMS', to: '/addblogs',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'CMS Listing', to: '/blogs/listing',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Object Models Listing', to: '/objectmodel',click:'' },
		   ],
		   dynamicsubitems:  true,
		   dynamicsublistcall:   'cmsmenu' ,
		   subitems: [
			 { icon: 'add',userType: 'Master'  , title: 'Create Object Models', to: '/addobjectmodel',click:'' },
			 { icon: 'add',userType: 'Master'  , title: 'Create CMS with Object Models', to: '/addblogom',click:'' },
			 { icon: 'add',userType: 'Master'  , title: 'Create CMS with pagebuilder', to: '/addblog/geditor',click:'' },
			 { icon: 'add',userType: 'Master'  , title: 'Create CMS templates', to: '/addcmstemplate',click:'' }
			]
		  },
		  
		  { icon: 'people',userType: 'Master'  , title: 'CONTACTS', to: '/contacts/#home/1',click:'', isMobileview: false, active: true,    showhead: false,items:[],
						  homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/contacts/#home/1',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/contacts/#home/1',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/contacts/#home/1',click:'' },
						    ],
						  dynamicsubitems:  true,
						  dynamicsublistcall:  'contactmenu',
						  subitems: [ 
							]
		  },
		  { icon: 'chat',userType: 'Master'  , title: 'CONVERSATIONS', click:'', isMobileview: '', active: true,    showhead: false,items:[], 
					homelist: [
					  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/inbox/all',click:'' },
					  { icon: 'chat',userType: 'Master'  , title: 'SMS', to: '/inbox/sms',click:'' },
					  { icon: 'call',userType: 'Master'  , title: 'Call', to: '/inbox/call',click:'' },
					],
					dynamicsubitems:  true,
					dynamicsublistcall:   'chatmenu' ,
					subitems: [
					 /*{ icon: 'home',userType: 'Master'  , title: 'Home', to: '/inbox/all',click:'' },
					 { icon: 'chat',userType: 'Master'  , title: 'New Message', to: '/inbox/sms',click:'' },
					 { icon: 'call',userType: 'Master'  , title: 'New Message', to: '/inbox/call',click:'' },
					 { icon: 'favorite',userType: 'Master'  , title: 'Favorites', to: '/voip-conversations/#favourites',click:'' } ,
					 { icon: 'more',userType: 'Master'  , title: 'Recents', to: '/inbox/all',click:'' } */
					]
			 },
		 
		 ],
		 
		 
		  

		  
		  sortingmenu33: [
		  { title: 'MY DESK',  icon: 'format_list_numbered',userType: ''  ,isMobileview: true, active: true,    showhead: false, to: '/mydesk/home',items:[] },
		  { title: 'FAVOURITES',  icon: 'format_list_numbered',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/mydesk/logs',items:[] },
		  { title: 'MY RECENT EVENTS',  icon: 'format_list_numbered',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/mydesk/logs',items:[] },
		  { title: 'API',  icon: 'format_list_numbered',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/mydesk/logs',items:[] },
		  { title: 'DONETALKING',icon: 'phone_in_talk',userType: 'Master' ,isMobileview: false,active: true,    showhead: false,
					items: [
					 { icon: 'today',userType: 'Master'  , title: 'Project Management', click:'', 
						    homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Dashboard', to: '/checklist/lists/all',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add New', to: '/checklist/projectsettings/',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'View Listing', to: '/checklist/lists/all',click:'' },
						    ],
						    dynamicsubitems:  true,
						    dynamicsublistcall:   'projectmenu' ,
						    subitems: [ ]
					  }, 
					 { icon: 'code',userType: 'Master'  , title: 'Codebook', click:'', 
						    homelist: [  ],
						    dynamicsubitems:  false,
						    dynamicsublistcall:   '' ,
						    subitems: [
								{ icon: 'code',userType: 'Master'  , title: 'Code Book libraries', to: '/codebook',click:'' },
								{ icon: 'note',userType: 'Master'  , title: 'Jupyter notebook', to: '/jupyterupload',click:'' },
								
							]
					  }, 
					  { icon: 'list', userType: 'Master'  , title: 'Forms', to: '/forms',click:'',homelist:[],dynamicsubitems:  false , subitems: [ ] },
					   
					]
			},
		  
		  
		  ],
		  
		  sortingmenu2: [
		    //Mobileview
			{ title: 'MY DESK',  icon: 'format_list_numbered',userType: ''  ,isMobileview: true, active: true,    showhead: false, to: '/mydesk/home',items:[] },
			{ title: 'My/Buy Number',  icon: 'tag',userType: ''  ,isMobileview: true, active: true,    showhead: false, to: '/voip',items:[] },
			{ title: 'Chat',  icon: 'chat',userType: ''  ,isMobileview: true, active: true,    showhead: false, to: '/inbox/all',items:[] },
			{ title: 'Dialer',  icon: 'dialpad',userType: ''  ,isMobileview: true, active: true,  click:'sheet',  showhead: false, to: '',items:[] },
			{ title: 'VOIP',  icon: 'format_list_numbered',userType: ''  ,isMobileview: true, active: true,    showhead: false, to: '/voip-conversations/#home',items:[] }, 
			 
			
			//Desktop view
			{ title: 'MY RECENT EVENTS',  icon: 'format_list_numbered',userType: ''  ,isMobileview: false, active: true,    showhead: false, to: '/mydesk/logs',items:[] },
			{ title: 'ABITMOBILE',  icon: 'phonelink',userType: 'Master'  ,isMobileview: false, active: true,    showhead: false,
				 items: [
					 { icon: 'home',userType: 'Master'  , title: 'VOIP', click:'', 
							homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/voip',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/voip',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/voip-conversations/#recents',click:'' },
						    ],
							dynamicsubitems:  false,
							dynamicsublistcall:   '' ,
							subitems: [
							 { icon: 'call',userType: 'Master'  , title: 'My Number', to: '/voip',click:'' },
							 { icon: 'alt_route',userType: 'Master'  , title: 'Call Routing', to: '/voip-conversations/#recents',click:'' },
							 { icon: 'mic',userType: 'Master'  , title: 'Voicemail Settings', to: '/voip/#home',click:'' } 
							]
					 },
					 { icon: 'home',userType: 'Master'  , title: 'Conversations', click:'', 
							homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/voip-conversations/#home',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/voip',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/voip-conversations/#recents',click:'' },
						    ],
							dynamicsubitems:  false,
							dynamicsublistcall:   '' ,
							subitems: [
							 { icon: 'home',userType: 'Master'  , title: 'Home', to: '/inbox/all',click:'' },
							 { icon: 'chat',userType: 'Master'  , title: 'New Message', to: '/voip-conversations/#newmessage',click:'' },
							 { icon: 'favorite',userType: 'Master'  , title: 'Favorites', to: '/voip-conversations/#favourites',click:'' } ,
							 { icon: 'more',userType: 'Master'  , title: 'Recents', to: '/voip-conversations/#recents',click:'' } 
							]
					 },
					 { icon: 'home',userType: 'Master'  , title: 'Calendar', click:'', 
						    homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/meeting/#home',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/add-meeting-availability',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/meeting',click:'' },
						    ],
						    dynamicsubitems:  false,
						    dynamicsublistcall:   '' ,
							subitems: [ 
							 { icon: 'event_available',userType: 'Master'  , title: 'Booking Calendar', to: '/meeting',click:'' },
							 { icon: 'event_note',userType: 'Master'  , title: 'SMS Calendar', to: '/alerts-calendar',click:'' } 
							] 
					  },
					  { icon: 'chat',userType: 'Master'  , title: 'Contacts', to: '/contacts/#home/1',click:'',
						  homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/contacts/#home/1',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/contacts/#home/1',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/contacts/#home/1',click:'' },
						    ],
						  dynamicsubitems:  true,
						  dynamicsublistcall:  'contactmenu',
						  subitems: [ 
							]
					  },
					  { icon: 'chat',userType: 'Master'  , title: 'SUBSCRIBERS / Stripe Plan', to: '/servicelist',click:'',homelist:[],dynamicsubitems:  false,subitems: [ ] }
					] 
			},
			{ title: 'ABITSWIFT',  icon: 'cloud',userType: 'Master'  ,isMobileview: false, items: [],active: true,    showhead: false,
				items: [
					 { icon: 'chat',userType: 'Master'  , title: 'Bot Services', to: '/knowledgeservice',click:'',
						 homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/knowledgeservice',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/knowledgeservice/add',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/knowledgeservice',click:'' },
						 ],
						 dynamicsubitems:  false,subitems: [ ] },
					 { icon: 'chat',userType: 'Master'  , title: 'Collection', to: '/collections',click:'',
						 homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/collections',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/collections',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/collections',click:'' },
						 ],
						 dynamicsubitems:  false,subitems: [ ] },
					 { icon: 'home',userType: 'Master'  , title: 'My devices', click:'', 
							homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/devices/googlehome',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/devices/googlehome',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/devices/googlehome',click:'' },
						    ],
							dynamicsubitems:  false,
							dynamicsublistcall:   '' ,
							subitems: [
							 { icon: 'mdi-google-home',userType: 'Master'  , title: 'Google home', to: '/devices/googlehome',click:'' },
							 { icon: 'mdi-amazon-alexa',userType: 'Master'  , title: 'Alexa', to: '/devices/alexa',click:'' }
							]
					 },
					 { icon: 'home',userType: 'Master'  , title: 'CMS', click:'', 
							homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/blogs',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add CMS', to: '/addblogs',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'CMS Listing', to: '/blogs/listing',click:'' },
							],
							dynamicsubitems:  true,
							dynamicsublistcall:   'cmsmenu' ,
							subitems: [
							 { icon: 'add',userType: 'Master'  , title: 'Create CMS with pagebuilder', to: '/addblog/geditor',click:'' },
							 { icon: 'add',userType: 'Master'  , title: 'Create CMS templates', to: '/addcmstemplate',click:'' }
							]
					 },
					 { icon: 'home',userType: 'Master'  , title: 'Commerce', click:'', 
							homelist: [],
							dynamicsubitems:  false,
							dynamicsublistcall:   '' ,
							subitems: [
							 { icon: 'list_alt',userType: 'Master'  , title: 'Product Listings', to: '/listings',click:'' },
							 { icon: 'widgets',userType: 'Master'  , title: 'Box services', to: '/boxservice',click:'' },
							 { icon: 'build',userType: 'Master'  , title: 'Offered services', to: '/services',click:'' },
							]
					 },
				 ]
			},
			{ title: 'DONETALKING',icon: 'phone_in_talk',userType: 'Master' ,isMobileview: false,active: true,    showhead: false,
					items: [
					 { icon: 'today',userType: 'Master'  , title: 'Project Management', click:'', 
						    homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Dashboard', to: '/checklist/lists/all',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add New', to: '/checklist/projectsettings/',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'View Listing', to: '/checklist/lists/all',click:'' },
						    ],
						    dynamicsubitems:  true,
						    dynamicsublistcall:   'projectmenu' ,
						    subitems: [ ]
					  }, 
					 { icon: 'code',userType: 'Master'  , title: 'Codebook', click:'', 
						    homelist: [  ],
						    dynamicsubitems:  false,
						    dynamicsublistcall:   '' ,
						    subitems: [
								{ icon: 'code',userType: 'Master'  , title: 'Code Book libraries', to: '/codebook',click:'' },
								{ icon: 'note',userType: 'Master'  , title: 'Jupyter notebook', to: '/jupyterupload',click:'' },
								
							]
					  }, 
					  { icon: 'list', userType: 'Master'  , title: 'Forms', to: '/forms',click:'',homelist:[],dynamicsubitems:  false , subitems: [ ] },
					   
					]
			},
			{ title: 'BLUISHTOOTH',  icon: 'developer_mode',userType: 'Master' ,isMobileview: false , items: [],active: true,    showhead: false,
				items: [
					  { icon: 'api',userType: 'Master'  , title: 'API', click:'', 
							homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '#',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '#',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '#',click:'' },
						    ],
							dynamicsubitems:  false,
							dynamicsublistcall:   '' ,
							subitems: [
							 { icon: 'api',userType: 'Master'  , title: 'API Details', to: '/contact/api',click:'' },
							 { icon: 'widgets',userType: 'Master'  , title: 'Recent events', to: '/contact/events',click:'' }, 
							]
					 },
					 { icon: 'home',userType: 'Master'  , title: 'My Account', click:'', 
							homelist: [],
							dynamicsubitems:  false,
							dynamicsublistcall:   '' ,
							subitems: [
							 { icon: 'list_alt',userType: 'Master'  , title: 'My profile', to: '/myprofile',click:'' },
							 { icon: 'widgets',userType: 'Master'  , title: 'Contact info', to: '/profile',click:'' },
							 { icon: 'build',userType: 'Master'  , title: 'My usage', to: '/myusage',click:'' },
							]
					 },
					 { icon: 'article',userType: 'Master'  , title: 'Templates', to: '/services/templates',click:'',homelist:[],dynamicsubitems:  false,subitems: [ ] }, 
					 { icon: 'home',userType: 'Master'  , title: 'My Database', click:'', 
							homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/database',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/database',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/database',click:'' },
						    ],
							dynamicsubitems:  true,
							dynamicsublistcall:   'dbmenu' ,
							subitems: [ 
							 { icon: 'apps',userType: 'Master'  , title: 'Apps', to: '/apps',click:'' },
							 { icon: 'library_books',userType: 'Master'  , title: 'Entity', to: '/entitybook',click:'' },
							 { icon: 'library_add',userType: 'Master'  , title: 'Tracking terms', to: '/trackingterms',click:'' },
							 { icon: 'folder_open',userType: 'Master'  , title: 'Data ingestion service', to: '/dis',click:'' },
							]
					 },
				 ]
				
			},
			{ title: 'SUDDENSTEP', icon: 'analytics',userType: 'Master',isMobileview: false  , items: [],active: true,    showhead: false,
					items: [
					 { icon: 'article',userType: 'Master'  , title: 'Documents', to: '/drive/files',click:'',homelist:[],dynamicsubitems:  false,subitems: [ ] }, 
					 { icon: 'cloud_circle',userType: 'Master'  , title: 'My Storage', to: '/mediastorage',click:'',homelist:[],dynamicsubitems:  false,subitems: [ ] }, 
					 { icon: 'miscellaneous_services',userType: 'Master'  , title: 'All services', to: '/services/all',click:'',homelist:[],dynamicsubitems:  false,subitems: [ ] }, 
					 ]
			},
		    		    
		    //Subaccount		    
		    { title: 'ABITMOBILE',  icon: 'phonelink',userType: 'Subaccount' ,isMobileview: false , active: true,    showhead: false, to: '',
				items:[
					 
					 { icon: 'home',userType: 'Master'  , title: 'Conversations', click:'', 
							homelist: [],
							dynamicsubitems:  false,
							dynamicsublistcall:   '' ,
							subitems: [
							 { icon: 'home',userType: 'Master'  , title: 'Home', to: '/voip-conversations/#home',click:'' },
							 { icon: 'chat',userType: 'Master'  , title: 'New Message', to: '/voip-conversations/#newmessage',click:'' },
							 { icon: 'favorite',userType: 'Master'  , title: 'Favorites', to: '/voip-conversations/#favourites',click:'' } ,
							 { icon: 'more',userType: 'Master'  , title: 'Recents', to: '/voip-conversations/#recents',click:'' } 
							]
					 },
					 { icon: 'home',userType: 'Master'  , title: 'Calendar', click:'', 
						    homelist: [ 
						    ],
						    dynamicsubitems:  false,
						    dynamicsublistcall:   '' ,
							subitems: [ 
							 { icon: 'home',userType: 'Master'  , title: 'Home', to: '/list-meeting-availability',click:'' } 
							] 
					  },
					  { icon: 'chat',userType: 'Master'  , title: 'Contacts', to: '/contacts/#home/1',click:'',
						  homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Home', to: '/contacts/#home/1',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add', to: '/contacts/#home/1',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'Listing', to: '/contacts/#home/1',click:'' },
						    ],
						  dynamicsubitems:  true,
						  dynamicsublistcall:  'contactmenu',
						  subitems: [ 
							]
					  },
					  { icon: 'chat',userType: 'Master'  , title: 'SUBSCRIBERS / Stripe Plan', to: '/servicelist',click:'',homelist:[],dynamicsubitems:  false,subitems: [ ] }
				] },
		    { title: 'ABITSWIFT',  icon: 'cloud',userType: 'Subaccount',isMobileview: false  , active: true,    showhead: false, to: '/mydesk/logs',
				items:[
					{ icon: 'home',userType: 'Master'  , title: 'CMS', click:'', 
							homelist: [
							],
							dynamicsubitems:  true,
							dynamicsublistcall:   'cmsmenu' ,
							subitems: [
							 { icon: 'home',userType: 'Master'  , title: 'Home', to: '/blogs/listing',click:'' }, 
							]
					 },
				] 
			},
		    { title: 'DONETALKING',  icon: 'phone_in_talk',userType: 'Subaccount' ,isMobileview: false , active: true,    showhead: false, to: '',items: [
					 { icon: 'today',userType: 'Master'  , title: 'Project Management', click:'', 
						    homelist: [
							  { icon: 'home',userType: 'Master'  , title: 'Dashboard', to: '/checklist/projectsettings/',click:'' },
							  { icon: 'add',userType: 'Master'  , title: 'Add New', to: '/checklist/projectsettings/',click:'' },
							  { icon: 'list',userType: 'Master'  , title: 'View Listing', to: '/checklist/projectsettings/',click:'' },
						    ],
						    dynamicsubitems:  true,
						    dynamicsublistcall:   'projectmenu' ,
						    subitems: [ ]
					  }, ]
		    },
		    { title: 'BLUISHTOOTH',  icon: 'developer_mode',userType: 'Subaccount' ,isMobileview: false , active: true,    showhead: false, to: '/mydesk/logs',items:[] },
		    { title: 'SUDDENSTEP',  icon: 'analytics',userType: 'Subaccount' ,isMobileview: false , active: true,    showhead: false, to: '/mydesk/logs',items:[] },
		  ],
		menuitem: [ ]
      }
    },
    
	filters: {
      
	  
	  formatdate1(date) {
	    if(date!='' && date !=null){ 
        	return moment(date).utc().format('YYYY-MM-DD');
		}else{
			return '';
		}
      },
	  formatdate(date) {
        return moment(date).utc().format('YYYY-MM-DD hh:mm');
      }, 
	  formatDateNew: function (inDate) {
		 // var date = new Date();
		//date.setTime(inDate.valueOf() - 60000 * inDate.getTimezoneOffset());
		var day = moment.unix(inDate).utc().format("YYYY-MM-DD hh:mm:ss a");
		
		return day;
	  }
  	},components: {
		Breadcrumbs,
		Dialer
	},
    computed: {
	   userid () {
	   if(this.$store.state.user){
			if(typeof this.$store.state.user.uid!=='undefined'){
				return this.$store.state.user.uid;
			}else{
				return '';
			}
		}else{
				return '';
			}
	  },loaddialog () {
        return this.$store.state.pageloading
      },
      openphone:{
		get: function () {
				return this.$store.state.openphone;
			},
			set: function (newValue) {
				this.$store.state.openphone = newValue
			}
	  },
	  appTitle () {
        return this.$store.state.appTitle 
      },
      footerTitle () {
       // return this.$store.state.appTitle +' - '+ process.env.consoledomain
        return this.$store.state.appTitle 
      },
      isAuthenticated () {
        return this.$store.getters.isAuthenticated
      },
      menuItems () {
        if (this.isAuthenticated) {
          return [   ]
        } else {
			  if(typeof this.$route.query.sid!=='undefined'){ 
				var slackid='?sid='+this.$route.query.sid;
			  }else{
				var slackid='';
			  }
			  return [
				{ title: 'Sign Up', path: '/signup'+slackid, icon: 'face' },
				{ title: 'Sign In', path: '/signin'+slackid, icon: 'lock_open' }
			  ]
        }
      },
      navcolor(){
		  //Nav bar color - Master account - success, Subaccount -  purple darken-1	 
		  if(this.$route.path == '/subaccount_login' || (this.$store.state.user  != null && this.$store.state.user != undefined && this.$store.state.user  != '' && this.$store.state.user.Type == 'Subaccount')){
				return 'purple darken-1';
		  }else{
				//return 'success';
				return 'grey darken-1';
		  }
		  
	  },
	  phcolor(){
			if(this.mobilestatus.length>0){
					var vm=this;
					var filterPhases = this.mobilestatus.filter(function (e) {
						return e.mobile == vm.dfrom;
					});
					var filterPhases2=filterPhases.reverse();
				   
				    if(typeof filterPhases2[0]!=='undefined'){ 
				  	 	
						if(filterPhases2[0].status=='initiated'){ 
							filterPhases2[0].color='orange';
						}else if(filterPhases2[0].status=='ringing'){ 
							filterPhases2[0].color='amber';
						}else if(filterPhases2[0].status=='answered'){ 
							filterPhases2[0].color='pink';
						}else if(filterPhases2[0].status=='completed'){ 
							filterPhases2[0].color='green';
						}else{
							filterPhases2[0].color='green';
						}
						
						
						return filterPhases2[0]
				    }else{ 
						return { color:'green', mobile: this.dfrom ,status: '',date: '',Direction: '' } 
					}
			}else if( this.dfrom !==''){
				return { color:'red', mobile: this.dfrom ,status: '',date: '',Direction: '' }
			}else{
				return { color:'grey', mobile: '' ,status: '',date: '',Direction: '' }
			}
	  },
	  naviconcolor(){
		  //Nav bar color - Master account - amber, Subaccount -  white
		  if(this.$route.path == '/subaccount_login' || (this.$store.state.user  != null && this.$store.state.user != undefined && this.$store.state.user  != '' && this.$store.state.user.Type == 'Subaccount')){
				return 'grey lighten-1';
		  }else{
				//return 'amber';
				return 'grey lighten-1';
		  }	
		  
	  },
       snack: {
		// getter
		get: function () {
		  return this.$store.state.snack
		},
		// setter
		set: function (newValue) {
		  this.$store.state.snack = newValue
		}
	  },
	  snackColor: {
		// getter
		get: function () {
		  return this.$store.state.snackColor
		},
		// setter
		set: function (newValue2) {
		  this.$store.state.snackColor = newValue2
		}
	  },
	  snackText: {
		// getter
		get: function () {
		  return this.$store.state.snackText
		},
		// setter
		set: function (newValue3) {
		  this.$store.state.snackText = newValue3
		}
	  },
	  callfwd: {
		get: function () {
		  return this.$store.state.callfwd
		},
		set: function (newValue3) {
		  this.$store.state.callfwd = newValue3
		}
	  },
	  dfrom: {
		get: function () {
		  return this.$store.state.dfrom
		},
		set: function (newValue3) {
		  this.$store.state.dfrom = newValue3
		}
	  },
	  dtomenuid: {
		get: function () {
		  return this.$store.state.dtomenuid
		},
		set: function (newValue3) {
		  this.$store.state.dtomenuid = newValue3
		}
	  },
	  log: {
		get: function () {
		  return this.$store.state.log
		},
		set: function (newValue3) {
		  this.$store.state.log = newValue3
		}
	  },
	  incoming: {
		get: function () {
		  return this.$store.state.incoming
		},
		set: function (newValue3) {
		  this.$store.state.incoming = newValue3
		}
	  },
	  inconn: {
		get: function () {
		  return this.$store.state.inconn
		},
		set: function (newValue3) {
		  this.$store.state.inconn = newValue3
		}
	  },
	  acceptcall: {
		get: function () {
		  return this.$store.state.acceptcall
		},
		set: function (newValue3) {
		  this.$store.state.acceptcall = newValue3
		}
	  },todoprojects() {
		  return this.$store.getters.getTodoProjects; 
	  }, 
	   contactmenu(){
		  return this.$store.state.contactmenu		  
	  },
	   projectmenu(){
		  return this.$store.state.projectmenu		  
	  },	   
	   cmsmenu(){
		  return this.$store.state.cmsmenu		  
	  },
	  allconvmessages: {
			  get: function () {
				  //return this.$store.state.allconvmessages
				 var vm=this
				  var filterPhases = this.$store.state.allconvmessages 
				  //~ var filterPhases = this.$store.state.allconvmessages.filter(function (e) {
							//~ return e.room == vm.userid;
				  //~ });
				  if(typeof filterPhases[0]!=='undefined'){  
					  var prop='offset';
					  var items= vm.$store.state.allconvmessages.filter((obj, pos, arr) => {
						var data= arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
						
					   /*var res= {
							"icon": "playlist_add_check",
							"title": "Finacial Proj",
							"to": "/checklist/lists/42",
							"click": "",
							"templatetype": "dis",
							"modified": "2021-05-14T11:23:00",
							"offset": arr[pos]["offset"],
						  };*/
						  
						  arr[pos]["icon"]='chat';
						  arr[pos]["title"]='star';
						  arr[pos]["to"]='/inbox/sms';
						  arr[pos]["click"]='';
						 // arr[pos]["title"]=arr[pos]['name'].charAt(0).toUpperCase();
						  arr[pos]["icontitle"]=arr[pos]['name'].charAt(0).toUpperCase();
						   arr[pos]["title"]=arr[pos]['text'];
						  
						 // console.log('%%%',arr[pos]["title"]);
						  
						
						return data;
					  });
					  
					   // return items.sort((a, b) => a.offset - b.offset); //asc
					   if(items.length>0){
						 //return items.sort(function(a,b){return b.last_nom>a.last_nom});
						 return items.sort((a, b) => b.offset - a.offset); //desc
					  }else{
						return [];
					  }
				  }else{
						return [];
				  }
			  },
			  set: function (newValue) {
				  this.$store.state.allconvmessages = newValue
			  }
		}, 
	   
    },
    methods: {
		 inboxdirectsubscribe(ouser,room){ 
				var chatsource='live2'; if(window.endpoint=='http://localhost:5000'){ var chatsource='local2'; 	}
				
				 var vm =this;
				 var uid = vm.$store.state.user.uid;
				 if(vm.$store.state.user.Type == 'Subaccount'){
					var uid = vm.$store.state.user.primaryuid
				 }else{
					var uid = vm.$store.state.user.uid;
				 }
				
				
				var r= Math.floor((Math.random() * 100) + 1);
				var topic=room;
				var groupid=this.userid+'-chatgroupone2'+chatsource+topic;
				var uid=uid;
				var vm=this;
				// vm.omessages=[]; vm.ousers=[];
				//vm.indeterminate=true; console.log();
				console.log('inboxdirectsubscribe:',room);
				
				axios.get(`${window.endpoint}/inbrowser/kafka-subscribe-inbox/`+topic+`/`+groupid+`/`+uid, {} ).then(dataset => {	

					 /*vm.$store.state.snack = true;
					 vm.$store.state.snackColor = 'info';
					 vm.$store.state.snackText = 'Joined to '+topic+'';*/
					// vm.indeterminate=false;  vm.inboxalertstatus=true;
					 
				}).catch(err => { 
				 	//vm.indeterminate=false;vm.inboxalertstatus=false;
				})

		 },
		callfn(sitem) {
			if(sitem.click == 'sheet'){
				this.sheet = !this.sheet;
			}
				
			
		},
		displaycondition(sitem) {
			//isAuthenticated && ((($store.state.user && ( sitem.userType =='' || sitem.userType == $store.state.user.Type)) || !$store.state.user)) && (!isMobile() && (sitem.isMobileview == '' || sitem.isMobileview))  && sitem.items.length<=0
			//console.log('sitem',sitem)
		if(this.isAuthenticated){
			if(((this.$store.state.user && ( sitem.userType =='' || sitem.userType == this.$store.state.user.Type)) || !this.$store.state.user)){
				//console.log('this.isMobile()',!this.isMobile())
				//console.log('sitem.isMobileview', sitem.isMobileview)
				
				if(!this.isMobile() && sitem.isMobileview !== false){
					//console.log('mobile true', sitem)
					//Mobile View
					return true;		
				}else if(!!this.isMobile() && sitem.isMobileview == false){
					//Desktop view
					return true;
				}else{
					return false;
				}
			}else{
				return false;
			}
		}else{
			return false
		}
			
			
		},
		isMobile() {
		   if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			 return false
		   } else {
			 return true
		   }
		 },
		dynamicmenu: function (type) {
		   if(type == 'projectmenu'){
				return this.$store.state.projectmenu
			}else if(type == 'contactmenu'){
				return this.$store.state.contactmenu
			}else if(type == 'cmsmenu'){
				return this.$store.state.cmsmenu
			}else if(type == 'dbmenu'){
				return this.$store.state.dbmenu
			}else if(type == 'chatmenu'){
				return this.allconvmessages
			}else{
				return [];
			}		  
	  },  
	  accept (){
	  //console.log('accept:',this.inconn);
	    if(this.inconn){
			this.inconn.accept();
			this.acceptcall=true;
			this.log = 'Call answered!';
		}
	 },reject (){
	 //console.log('reject:',this.inconn);
	 
	 	if(this.inconn){
	   	 this.inconn.reject();
		 this.incoming=false;
		 this.acceptcall=false;
		 this.log = 'Call rejected!';
		}
	 },showphone() {
         this.openphone=true;
      },directsubscribe(topic,from){
		    var groupid=topic+'-default-mobile-group';
			var topic1=from.replace("+", "topic"); var topic='mobile-'+topic1;
			axios.get(`${window.endpoint}/gatewayc2/kafka-subscribe-mobile/`+topic+`/`+groupid, {} ).then(dataset => {					
				//console.log('...Subscribed to '+topic+'');
			}).catch(err => {  	})

	  },userSignOut () {
        this.$store.dispatch('userSignOut')
      },
	   snackbarhide () {
          $('.snackbardiv').hide();
      },sendMessage() {
         //parent.postMessage('This is the message from your iframe vuejs page', 'http://localhost:3000');
         var a = 5;
		 window.parent.postMessage(['varA', a], '*'); // put this in some sort of function, ready, or whatever - you can call it multiple times if you need to as the code in the parent is an eventListener
     },routerback(){
		 var vm  = this;
		 vm.$router.go(-1)
	 },routernext(){
		 var vm  = this;
		 vm.$router.go(1)
	 },
	 route(callfunction){
		 if(callfunction=='userSignOut'){
			 this.userSignOut();
		 }		 
	 },
    },
    created: function () {
		//this.socket=io("http://localhost:5000");
		 this.socket=io(`${window.socketendpoint}`);
		 
		if(this.userid){ 
			this.$store.dispatch('listUserNum',{uid:this.userid,sid:''}) 
			this.$store.dispatch('setMenuList'); //Calling Dynamic contact & Project menu here
		
			//this.sendMessage();
			
			//conversation
			var vm =this;
			if(vm.$store.state.user.Type == 'Subaccount'){
			var uid = vm.$store.state.user.primaryuid
			}else{
			var uid = vm.$store.state.user.uid;
			}
			
			
			 if(!vm.isMobile()){
			   //vm.androidid='testela';
			   console.log('androidid0:',1);  
			   window.addEventListener("flutterInAppWebViewPlatformReady", function(event) { console.log('androidid1:',1);  
					window.flutter_inappwebview.callHandler('handleId').then(function(result) { console.log('androidid2:',2);  
						// print to the console the data coming
						// from the Flutter side.
						  alert(result["id"]);  
						console.log('androidid3:',result["id"]);  
						vm.androidid=result["id"]; 
						 //document.getElementById("id").innerHTML = result["id"];
					 }).catch(err => {
						 console.log('err1:',err);  
					 });
			  }).catch(err => {
					 console.log('err2:',err);  
			  });
		   }else{
		   console.log('Desktop:',2);  
		   }
		 	
			
			
			vm.$store.state.oroom = vm.userid;
			vm.$store.state.ouser={
				"uid": uid,
				"type":vm.$store.state.user.Type,
				"name": vm.$store.state.user.displayName,
				//"projectname": vm.$store.getters.getTodolistid.title,
				"room": vm.$store.state.oroom,
				"color":'primary',
				"status":1,
			}
			vm.inboxdirectsubscribe(vm.$store.state.ouser,uid);
		 
		 } 
	},
	watch: {
	   'userid': {
            handler: function (after, before) { 
				//calling after signin
				this.$store.dispatch('setMenuList'); //Calling Dynamic contact & Project menu here
				
            },
            deep: true
        }	
    },
	mounted() {
		if(this.userid){ 
			 //console.log('&&&:');
			 this.socket.on('KAFKAMOBILE', (data) => {
				 if(data.message!=='undefined'){
					 var newdata=JSON.parse(data.message);
					 //console.log('KAFKAMOBILE:',newdata);
					 this.mobilestatus.push(newdata);
				  }
			   
			 });   
			 
			  
			 //conversation
				var vm =this;
				if(vm.$store.state.user.Type == 'Subaccount'){
				var uid = vm.$store.state.user.primaryuid
				}else{
				var uid = vm.$store.state.user.uid;
				}
			 
			 
			     vm.socket.on(vm.inboxmsgpre+uid+uid, (data) => {
					 console.log('setup Allinbox New message added',vm.inboxmsgpre+uid+uid,data);
					 this.allconvmessages = [...this.allconvmessages, data];
				 }); 
			 
	    }
		
	},
  }
</script>
<style>
[v-cloak] > * { display:none; }
[v-cloak]::before { content: "loading..."; }

.home-headertoolbar {
    z-index: 5;
}
.home-navigationdrawer {
    z-index: 6;
}


a:hover{
text-decoration:none!important;
}
a:hover{
text-decoration:none!important;
}
a.v-btn{
text-decoration:none!important;
}
.tabs__content { min-height: 100vh; }

.nomargin ,.nomargin label,.nomargin v-label  {
    margin-bottom: 0rem !important;
    padding-bottom: 0rem !important;
    top: 0px !important;
    margin-top:0px !important;
    padding-top:0px !important;
}
[disabled] {
    cursor: not-allowed;
}
.tabgrey .v-tabs__div {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    /*background: rgba(0,0,0,.2);*/
    margin: 5px;
}
.v-toolbar__content, .v-toolbar__extension {
	/*padding: 0 5px !important; */
}
.v-list__group__items--no-action .v-list__tile {
    padding-left: 30px!important;
}
label {
    display: inline-block;
    margin-bottom: 0rem!important;
}
.v-dialog.openphone {
	overflow-y: unset!important;
	border-radius: 2px!important;
}
.v-bottom-sheet.v-dialog.v-bottom-sheet--inset {
    max-width: 20%!important;
    min-width: 0;
}

.second--sub-group >.v-list__group__items >div >a.v-list__tile,.second--sub-group >.v-list__group__items >div >.v-list__tile {
    padding-left: 75px!important;
}
.second--sub-group >a.v-list__tile{ 
    padding-left: 72px!important;
}
 
.v-list--dense .v-list__group .v-subheader.homelist {
    height: 28px !important;
}
.homelist .v-btn .v-btn__content .v-icon
{
    font-size: 18px !important;	
}

.homelist > .v-list__tile__title{
	    height: auto !important;
}
.second--sub-group >.v-list__group__items >div >a>.v-list__tile__action{
	min-width: 35px !important;
}

.third-level{
	padding-left: 25px!important;  
	/*75*/
}
.theme--light.v-list.third-level{
	padding-top: 0px !important; 
	padding-bottom: 0px !important; 
}

.theme--light.v-list.third-level .v-list__group--active:after, .theme--light.v-list.third-level .v-list__group--active:before {
    background: rgba(0,0,0,0);
}
.third-level .v-list__tile{
	padding: 0px !important; 
}

</style>



// WEBPACK FOOTER //
// src/App.vue